import { render, staticRenderFns } from "./onlyUpload.vue?vue&type=template&id=5e6c2082&scoped=true"
import script from "./onlyUpload.vue?vue&type=script&lang=js"
export * from "./onlyUpload.vue?vue&type=script&lang=js"
import style0 from "./onlyUpload.vue?vue&type=style&index=0&id=5e6c2082&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e6c2082",
  null
  
)

export default component.exports